import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { Loader2 } from "lucide-react";
import { useAuth } from "@/context/AuthContext";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function AuthCallback() {
  const { API, setSessionUser } = useAuth();
  const nav = useNavigate();
  const processed = useRef(false);

  useEffect(() => {
    // Synchronous guard against StrictMode double-invocation
    if (processed.current) return;
    processed.current = true;

    const hash = window.location.hash || "";
    const m = hash.match(/session_id=([^&]+)/);
    const sessionId = m ? decodeURIComponent(m[1]) : null;
    if (!sessionId) { nav("/login"); return; }

    (async () => {
      try {
        const { data } = await axios.post(
          `${API}/auth/google/session`,
          { session_id: sessionId },
          { withCredentials: true }
        );
        setSessionUser(data.user);
        // Clean URL & route to home (or admin if admin)
        window.history.replaceState({}, "", "/");
        nav(data.user.role === "admin" ? "/admin" : "/", { replace: true, state: { user: data.user } });
      } catch (err) {
        nav("/login?error=google", { replace: true });
      }
    })();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div data-testid="auth-callback" className="min-h-screen flex flex-col items-center justify-center bg-[#FAFAF7] gap-4">
      <Loader2 className="w-10 h-10 animate-spin text-[#6B1A24]" strokeWidth={1.5} />
      <div className="label-eyebrow">Signing you in</div>
      <p className="text-sm text-[#5C5454]">Just a moment…</p>
    </div>
  );
}
